import { FC } from "react";
import { LoaderIcon } from "../../ui/icons";

export const OnProgress: FC<React.PropsWithChildren> = () => {
  return (
    <>
      <LoaderIcon className="animate-spin" />

      <div className="mt-6 dark:text-white">
        Your company and plan are being created.
      </div>
    </>
  );
};
